/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { AboutVirdioPage } from "../pages/AboutVirdio";
import { AskMyraPage } from "../pages/AskMyra";
import { HowItWorksPage } from "../pages/HowItWorks";
import SelfAssessment2 from "./SelfAssessment";
import { LandingPage } from "../virdioHealth/LandingPage";
import { AboutUs } from "../virdioHealth/About";
import { ContactUs } from "../virdioHealth/ContactUs";
import { RegisterScreen, VerifyScreen, SubscriptionScreen, PaymentScreen, SettingsScreen } from "./screens/AuthScreens";
function AppRoutesInner() {
    const hostname = window.location.hostname;
    const isForcedHome = window.location.search.indexOf('homevirdiohealth') > 0;
    const RootComponent = hostname === "virdiohealth.com" || hostname === "www.virdiohealth.com" || isForcedHome ? LandingPage : SelfAssessment2;

    return (
        <>
            <Switch>
                <Route path="/" exact component={RootComponent} />
                <Route path="/register" component={RegisterScreen} />
                <Route path="/verify" component={VerifyScreen} />
                <Route path="/subscription" component={SubscriptionScreen} />
                <Route path="/payment" component={PaymentScreen} />
                <Route path="/settings" component={SettingsScreen} />
                <Route path="/ask-myra" component={AskMyraPage} />
                <Route path="/how-it-works" component={HowItWorksPage} />
                <Route path="/about" component={AboutVirdioPage} />
                <Route path="/about-us" component={AboutUs} />
                <Route path="/contact-us" component={ContactUs} />
            </Switch>
        </>
    );
}
export default function AppRoutesV2() {
    return (
        <Router>
            <AppRoutesInner />
        </Router>
    );
}
